import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@material-ui/core";
import { DateNavigator } from "./DateNavigator";
import { PhotoGallery } from "@roc/ui";


export interface PhotoGalleryImage {
  key: string;
  url: string;
}
export interface PhotoGalleryByDate {
  date: string;
  photos: PhotoGalleryImage[];
}
interface PhotoGalleryProps {
  selectedPhotoKey?: string;
  photos: PhotoGalleryByDate[];
  enableZoom?: boolean;
  minZoomScale?: number;
  maxZoomScale?: number;
}


export const PhotoGalleryByDate: React.FC<PhotoGalleryProps> = ({
  photos: photosPerDate,
  selectedPhotoKey,
  enableZoom = false,
  minZoomScale = 1,
  maxZoomScale = 3,
}) => {
  const [galleryKey, setGalleryKey] = useState(0);
  const [dateIndex, setDateIndex] = useState(0);
  const current = photosPerDate[dateIndex] ?? { date: "", photos: [] };
  const images = current.photos;

  const dateChips = useMemo(
    () => photosPerDate.map((d) => d.date),
    [photosPerDate]
  );

  useEffect(() => {
    setGalleryKey(prev => prev + 1);
  }, [dateIndex])

  return (
    <Box display="flex" flexDirection="column" gridGap="8px" height="100%">
      <DateNavigator dates={dateChips} selectedIndex={dateIndex} onSelect={setDateIndex} />
      <Box flex="1 1 0" minHeight={0}>
        <PhotoGallery key={galleryKey} photos={images} enableZoom={enableZoom} minZoomScale={minZoomScale} maxZoomScale={maxZoomScale} />
      </Box>
    </Box>
  );
};
